import gql from 'graphql-tag';

export const UpdateInlineCommentMutation = gql`
	mutation UpdateInlineCommentMutation($input: UpdateCommentInput!) {
		updateComment(input: $input) {
			id
		}
	}
`;
